const signalR = require("@microsoft/signalr");
import { mapState, mapMutations } from "vuex";
import { conversion, countDownS, GetItemDuration, formatDate } from "@/tool";
import Picture from "@/components/picture";
import Button from "@/components/button";
import Avatar from "@/components/avatar";
import Award from "@/components/award";
import stockAward from "@/components/stockAward";
import countDown from "@/components/countDown";
import { CustomBlockTitle } from "@/partials/custom_block_title";
import InteractivePanel from "@/components/interactive_panel";
import room_item from "./components/RoomItem.vue";
import new_room from "./components/NewRoom.vue";
import battleCaseDetail from "./components/battleCaseDetail.vue";
import * as apis from "@/api";
import Number from "@/components/AnimateNumber/index.vue";

export default {
  name: "battle",

  components: {
    "c-picture": Picture,
    "c-button": Button,
    "c-avatar": Avatar,
    "c-award": Award,
    "c-stockAward": stockAward,
    "p-custom-block-title": CustomBlockTitle,
    "c-interactive-panel": InteractivePanel,
    "c-room-item": room_item,
    "c-new-room": new_room,
    "c-battleCaseDetail": battleCaseDetail,
    "c-number": Number,
    "c-countDown": countDown,
  },

  filters: {
    conversion,
    GetItemDuration,
  },

  data() {
    return {
      tabs: 0,
      notice_modal_show: false,
      battle_challenge_des_show: false,
      battle_challenge_receivedGift_show: false,
      battle_challenge_des_btn_show: false,
      server_time: null,
      mobile_ranking_flag: false,
      conn: null,
      roomList: [],
      total: 0,
      battleCaseList: [],
      pageIndex: 1,
      pageSize: 20,
      GameHistory: {
        today_list: null,
        yesterday_list: null,
        yesterday_star: {
          name: "",
          avatar: "",
          totalProfit: 0,
        },
        curTab: 0,
      },
      /** 加入房间 模态框 */
      join_room_modal: {
        flag: false,
        password: "",
        hasPassword: false,
        roomid: 0,
        price: 0,
      },
      /** 创建房间 模态框 */
      create_room_modal: {
        flag: false,
      },
      /** 箱子详情 */
      case_detail_modal: {
        flag: false,
        caseInfo: {},
      },
      lastCallTimestamp: 0,
      battleChallengeDetail: {
        isCurrentlyInChallenge: false, //当前是否正在连胜挑战
        winningSteakCount: 0, //连胜次数
        firstTickePrice: 0, //连胜第一次门票价格
        lastTicketPrice: 0, //最后一次连胜门票价格
        receivedGift: false, //是否已经领取奖励
        giftAmount: 0, //奖励金额
        cdkGiftRate: 0, //奖励等级： 1:0,3:1,5:3,8:10,12:20
        countDownSeconds: 0, //完成时间倒计时
        isChallengeEnable: false, //是否可以连胜挑战
        winningRoomId: 0, //连胜房间ID
      },
      countDownVauless: 0,
      isBtnAi: false, //是否是匹配AI按钮
      isBtnAiRoomId: "", //匹配AI按钮对应的房间ID
      cdkGiftRateList: [], //奖励等级
      curCDKRateObj: {
        num: 0,
        rate: 0,
      }, //当前奖励等级信息
      isShowShaixuan: false,
    };
  },
  computed: {
    ...mapState(["user"]),
    curUserRealId() {
      return parseInt(this.user.id);
    },
  },
  watch: {
    isHappyCoin(val, oldVal) {
      if (val == oldVal) return;
      this.initHub();
    },
  },
  created() {
    this.initHub();
  },
  beforeRouteLeave(to, from, next) {
    if (this.$caseBattleHub.isBattleRoute(to)) {
      next();
      return;
    }

    this.$caseBattleHub.stopHub().then(next).catch(next);
  },
  beforeDestroy() {
    this.DestoryListen();
  },

  methods: {
    ...mapMutations(["setSpinShow"]),
    switchTabs(index) {
      if (index == 1 && !this.user.nickname)
        return this.$store.commit("setloginModal", true);

      if (this.tabs == index) return;

      if (index == 0) {
        this.pageIndex = 1;
      }

      this.tabs = index;
      this.CGRequestRoomList();
    },
    async initHub() {
      this.DestoryListen();
      await this.$caseBattleHub.initHub(this.isHappyCoin);
      this.$caseBattleHub.onConnected = () => {
        this.initBattleData(); //初始化对战数据
      };

      this.$caseBattleHub.onReconnected = () => {
        this.initBattleData(); //初始化对战数据
      };

      if (this.$caseBattleHub.conn.state == "Connected") {
        //连接存在
        this.initBattleData();
      }
    },
    //取消监听
    DestoryListen() {
      this.$caseBattleHub.onConnected = null;
      this.$caseBattleHub.onReconnected = null;
      this.$caseBattleHub.conn.off("GCUpdateRoomRecv");
      this.$caseBattleHub.conn.off("GCChallengeFailedRecv");
      // console.log("取消监听对战房间列表");
      this.setSpinShow(false);
    },
    async initBattleData() {
      this.roomList = [];
      this.pageIndex = 1;
      await this.CGReqBattleChallengeDetails(); //获取连胜挑战信息
      await this.CGRequestRoomList(); //获取房间列表
      await this.CGReqBattleCase(); //获取箱子列表
      await this.CGReqBattleRanking(); //获取排行榜

      //监听更新房间
      this.$caseBattleHub.conn.on("GCUpdateRoomRecv", (data) => {
        // console.log("更新房间", data);
        var self = this.tabs == 1;

        if (self && data.room.memberid != this.user.id) return;

        var roomindex = this.roomList.findIndex(
          (item) => item.id == data.room.id
        );

        this.server_time = new Date(data.server_time.replace(/\-/g, "/"));

        if (roomindex > -1) {
          //房间存在更新房间
          this.roomList[roomindex] = data.room;
        } else {
          //房间不存在插入到头部
          if (this.pageIndex == 1) {
            this.roomList.pop();
            this.roomList.unshift(data.room);
          }
        }
      });
    },
    createRoom(data) {
      if (this.isHappyCoin) {
        data.UseHappyCoin = true;
      }
      this.$caseBattleHub.conn
        .invoke("GCRequestCreateRoom", data)
        .then((lpMsg) => {
          if (lpMsg.success) {
            // console.log(lpMsg);
            this.$toast.success(lpMsg.data);
            this.$refs.cNewRoom.reset();
            this.create_room_modal.flag = false;
            this.isShowShaixuan = false;
            this.$store.commit("setInfo");
            this.CGRequestRoomList(); //获取房间列表
          } else {
            this.$toast.error(lpMsg.msg);
            this.$refs.cNewRoom.reset();
          }
        });
    },
    CGReqBattleCase() {
      this.$caseBattleHub.conn.invoke("GCBattleCaseList", !!this.isHappyCoin).then((lpMsg) => {
        this.battleCaseList = lpMsg.data.caselist;
      });
    },
    async CGRequestRoomList() {
      var self = this.tabs == 1;
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        self,
      };
      if (this.isHappyCoin) {
        params.UseHappyCoin = true;
      }
      let lpMsg = await this.$caseBattleHub.conn.invoke("GCRequestRoomList", params);
      if (lpMsg.success) {
        this.total =
          lpMsg.data.rooms.totalItems > 480 ? 480 : lpMsg.data.rooms.totalItems;
        this.roomList = lpMsg.data.rooms.data;
        console.log(222222222222, lpMsg.data.rooms.data);
        this.pageIndex = lpMsg.data.rooms.pageNumber;
        this.server_time = new Date(lpMsg.data.server_time.replace(/\-/g, "/"));
      } else {
        this.$toast.error("请求失败");
      }
    },
    CGReqBattleRanking() {
      this.$caseBattleHub.conn
        .invoke("GCRequestBattleRanking")
        .then((lpMsg) => {
          // console.log(lpMsg);
          this.GameHistory.yesterday_list = lpMsg.data.yesterday_list;
          // console.log(this.GameHistory.yesterday_list);
          this.GameHistory.today_list = lpMsg.data.today_list;
          if (this.GameHistory.yesterday_list.length > 0) {
            this.GameHistory.yesterday_star =
              this.GameHistory.yesterday_list[0];
            this.GameHistory.yesterday_list.splice(0, 1);
          }
        });
    },
    async onJoinChallengeHandle() {
      await this.CGReqBattleChallengeDetails();
      this.battle_challenge_des_show = true;
      this.battle_challenge_des_btn_show = true;
    },
    //获取连胜挑战信息GCRequestChallengeInfo接口
    CGReqBattleChallengeDetails() {
      this.$caseBattleHub.conn
        .invoke("GCRequestChallengeInfo")
        .then((cpMsg) => {
          console.log("获取连胜挑战信息==GCRequestChallengeInfo", cpMsg);
          if (!cpMsg.data.isChallengeEnable) {
            //连胜挑战未开启,接口只返回isChallengeEnable字段，其他字段不返回
            this.battleChallengeDetail.isChallengeEnable =
              cpMsg.data.isChallengeEnable;
            return;
          }
          this.battleChallengeDetail = cpMsg.data;
          this.countDownVauless =
            Date.now() + this.battleChallengeDetail.countDownSeconds * 1000;
          let cdkGiftRate = this.battleChallengeDetail.cdkGiftRate.split(",");
          this.cdkGiftRateList = [];
          cdkGiftRate.forEach((item) => {
            let arr = item.split(":");
            if (arr[0] > 1) {
              let obj = {
                num: arr[0],
                rate: arr[1],
              };
              this.cdkGiftRateList.push(obj);
            }
          });
        });
      setTimeout(() => {
        //获取当前奖励等级
        this.curCDKRateObj = this.cdkGiftRateList.find(
          (item, index) =>
            (this.battleChallengeDetail.winningSteakCount <= item.num &&
              index == 0) ||
            (this.battleChallengeDetail.winningSteakCount >= item.num &&
              ((index + 1 <= this.cdkGiftRateList.length - 1 &&
                this.battleChallengeDetail.winningSteakCount <
                this.cdkGiftRateList[index + 1].num) ||
                index == this.cdkGiftRateList.length - 1))
        );
        console.log("curCDKRateObj===", this.curCDKRateObj);
      }, 2000);
    },
    //加入连胜挑战
    async onGCRequestJoinChallenge() {
      await this.CGReqBattleChallengeDetails();
      if (this.battleChallengeDetail.isCurrentlyInChallenge) {
        this.$toast.error("已参加连胜挑战");
        return;
      }
      if (this.battleChallengeDetail.winningSteakCount < 1) {
        this.$toast.error("暂无资格参加连胜挑战");
        return;
      }
      this.$caseBattleHub.conn
        .invoke("GCRequestJoinChallenge")
        .then((lpMsg) => {
          // console.log("参加连胜挑战lpMsg===", lpMsg);
          if (lpMsg.success) {
            this.$toast.success(lpMsg.data);
            this.battle_challenge_des_show = false;
            this.CGReqBattleChallengeDetails();
          } else {
            this.$toast.error(lpMsg.msg);
          }
        });
    },
    //  退出连胜挑战领取连胜挑战奖励
    async onGCReceiveReward() {
      this.$caseBattleHub.conn.invoke("GCRequestReceiveGift").then((lpMsg) => {
        // console.log("退出连胜挑战领取连胜挑战奖励lpMsg===", lpMsg);
        if (lpMsg.success) {
          this.$toast.success(lpMsg.data);
          this.battle_challenge_receivedGift_show = false;
          this.CGReqBattleChallengeDetails();
        } else {
          this.$toast.error(lpMsg.msg);
        }
      });
    },
    //倒计时结束
    async onCoundownDinished() {
      await this.CGReqBattleChallengeDetails();
      //如果倒计时结束，返回连胜挑战状态还存在，过1秒再次请求连胜挑战详情
      if (this.battleChallengeDetail.isCurrentlyInChallenge) {
        setTimeout(() => {
          this.CGReqBattleChallengeDetails();
        }, 1000);
      }
    },
    onRoomEnd(room) {
      if (this.isBtnAi && this.isBtnAiRoomId == room.id) {
        //如果是匹配AI按钮跑完，重新请求连胜挑战详情
        this.CGReqBattleChallengeDetails();
      }
      if (this.tabs != 1) {
        this.roomList.sort((a, b) => {
          return a.roomState - b.roomState;
        });
      }

      const now = Date.now();
      // 检查当前时间与上次调用时间的间隔是否大于等于2秒
      if (
        now - this.lastCallTimestamp >= 1000 ||
        this.lastCallTimestamp === 0
      ) {
        this.$store.commit("setInfo");
        // 更新上次调用的时间戳
        this.lastCallTimestamp = now;
      }
    },
    async openJoinRoomModal(room) {
      console.log("加入房间room", room);
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);

      if (room.roomState != 0) return;

      //如果是匹配AI按钮，标注一下
      if (room.btnType && room.btnType == "ai") {
        this.isBtnAi = true;
        this.isBtnAiRoomId = room.id;
      } else {
        this.isBtnAi = false;
        this.isBtnAiRoomId = "";
      }

      if (this.curUserRealId == room.memberid) {
        this.InviteBotJoin(room);
        return;
      }

      this.join_room_modal.id = room.id;
      this.join_room_modal.hasPassword = room.password ? true : false;
      this.join_room_modal.password = "";
      this.join_room_modal.price = room.roomPrice;
      this.join_room_modal.flag = true;
    },
    submit_join_room() {
      this.joinRoom(
        this.join_room_modal.id,
        this.join_room_modal.hasPassword ? this.join_room_modal.password : ""
      );
      this.join_room_modal.flag = false;
    },
    openCreateRoomModal() {
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);

      this.create_room_modal.flag = true;
      this.isShowShaixuan = true;
    },
    async openCaseDetailModal(item) {
      const case_info_response = await apis.api_CaseDetail(item.id);

      if (case_info_response.data.code !== 0) {
        return;
      }

      const respone = case_info_response.data.data;

      let case_info = respone.caseInfo;
      let case_awards = respone.items;
      var currentTotal = 0;
      var totalRate = case_awards
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);

      case_awards.forEach((item, index) => {
        let weight = Number(item.viewRate);
        let start = Number((currentTotal + (weight > 0 ? 0.01 : 0)).toFixed(2));

        let startVal, endVal;

        if (Number.isInteger(item.viewRate) && Number.isInteger(currentTotal)) {
          startVal = currentTotal;
          currentTotal += item.viewRate;
          endVal = currentTotal - 1;
          this.$set(item, 'rollRangeStr', `${startVal}-${endVal}`);
        } else {
          let s = currentTotal;
          let e = currentTotal + weight;
          currentTotal = e;
          this.$set(item, 'rollRangeStr', `${(s + (Number.isInteger(s) ? 0 : 0.01)).toFixed(Number.isInteger(s) ? 0 : 2)}-${e.toFixed(Number.isInteger(e) ? 0 : 2)}`);
        }
        item.viewRate = Math.ceil((weight / totalRate) * 10000000) / 100000;
      });


      this.case_detail_modal.caseInfo = { caseInfo: case_info, items: case_awards };
      this.case_detail_modal.flag = true;
    },
    onPageChange() {
      this.CGRequestRoomList();
    },
    joinRoom(id, pwd) {
      if (!this.user.nickname) {
        return this.$store.commit("setloginModal", true);
      }

      var data = {
        roomId: id,
        password: pwd,
        seatIndex: -1, //默认-1，表示不指定座位，服务器随机分配座位
      };

      this.$caseBattleHub.conn
        .invoke("GCRequestJoinRoom", data)
        .then((lpMsg) => {
          if (lpMsg.success) {
            this.$toast.success(lpMsg.data);
            //this.$store.commit('setInfo');
          } else {
            this.$toast.error(lpMsg.msg);
            if (lpMsg.msg.indexOf("余额不足") > -1) {
              this.$store.commit("setPayModal", true);
            }
          }
        });
    },
    async InviteBotJoin(room) {
      var data = { 
        RoomId: room.id ,
        seatIndex: -1, //默认-1，表示不指定座位，服务器随机分配座位
    };
      this.$caseBattleHub.conn
        .invoke("GCRequestFakerJoinRoom", data)
        .then((lpMsg) => {
          if (lpMsg.success) {
            this.$Message.success(lpMsg.data);
            //this.$store.commit('setInfo');
            this.CGRequestRoomList(); //获取房间列表
          } else {
            this.$Message.error(lpMsg.msg);
          }
        });
    },
    handleShowRoomDetail(item) {
      this.$router.push({
        name: this.isHappyCoin ? "happyCoinBattleDetail" : "battleDetail",
        params: { id: item.id },
        query: this.$route.query || {}
      });
    },
    handleMobileJoinPk(item, btnType) {
      if (item.roomState != 0) return this.handleShowRoomDetail(item);
      this.openJoinRoomModal({ ...item, btnType });
    },
  },
};
